// Action Types
import {GET_TRANSACTION_SUCCESS, GET_TRANSACTIONS_SUCCESS, ADD_TRANSACTION_SUCCESS, ADD_TRANSACTION_ERROR, UPDATE_TRANSACTION_ERROR} from '../actions/actionTypes';

// Utils
import { getNewState } from '../shared/utils/frontend';

// Initial State
const initialState = {};

export default function transactionFormReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TRANSACTION_SUCCESS: {
      const {payload: transaction} = action;
      return getNewState(state, {transaction});
      break;
    }
    case ADD_TRANSACTION_SUCCESS: {
      const {payload: transaction} = action;
      return getNewState(state, {transaction});
      break;
    }
    case ADD_TRANSACTION_ERROR: {
      const {payload: transaction} = action;
      return getNewState(state, {transaction});
      break;
    }
    case UPDATE_TRANSACTION_ERROR: {
      const {payload: transaction} = action;
      return getNewState(state, {transaction});
      break;
    }
    default:
      return state;
  }
}
